import * as MutationTypes from './mutation-types'

export default {
  state: {
    filter: {
      date: {
        initDate: null,
        endDate: null
      }
    }
  },
  mutations: {
    [MutationTypes.INIT_DATE_FILTER] (state, payload) {
      state.filter.date.initDate = payload
    },
    [MutationTypes.END_DATE_FILTER] (state, payload) {
      state.filter.date.endDate = payload
    }
  },
  getters: {
    getDateFilter (state) {
      return state.filter.date
    }
  }
}
